import React, { useState } from 'react';
import '../css/ReferralsPage.css';

const ReferralsPage = () => {
  const [email, setEmail] = useState('');
  const [copyMsg, setCopyMsg] = useState(false);
  const referralLink = "https://redfibre.in/referral/abc123";

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopyMsg(true);
    setTimeout(() => setCopyMsg(false), 2000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Referral sent to:", email);
    setEmail('');
  };

  return (
    <div className="referrals-container">
      <div className="referrals-content">
        <h1 className="referrals-title">Refer & Grow</h1>
        <p className="referrals-description">
          Invite others to Red Fibre and earn rewards when they join and activate their workspace. 
          Grow the ecosystem — together.
        </p>
        
        <div className="referral-link-container">
          <span className="referral-link">{referralLink}</span>
          <button onClick={handleCopy} className="copy-button">
            {copyMsg ? 'Copied!' : 'Copy'}
          </button>
        </div>

        <form onSubmit={handleSubmit} className="referral-form">
          <label className="form-label">Send Referral via Email</label>
          <input
            type="email"
            placeholder="Enter email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="email-input"
          />
          <button type="submit" className="submit-button">
            Send Invite
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReferralsPage;